import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { API_URL } from '../../config';
import SiteLayout from '../../layouts/SiteLayout';
import Header from '../../components/Header/Header';

const PermissionsDetails: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    const navigate = useNavigate();
    const { token } = useAuth();
    const isNew = !id || id === 'new';

    const [key, setKey] = useState('');
    const [description, setDescription] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        const fetchData = async () => {
            if (!isNew && token) {
                setLoading(true);
                try {
                    console.log("Fetching permission", id);
                    const response = await fetch(`${API_URL}/v1/admin/permissions/${id}`, {
                        headers: { 'Authorization': `Bearer ${token}` }
                    });
                    if (response.ok) {
                        const data = await response.json();
                        setKey(data.key);
                        setDescription(data.description || '');
                    } else {
                        console.error("Failed to fetch permission details");
                    }
                } catch (error) {
                    console.error("Error loading data:", error);
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchData();
    }, [id, isNew, token]);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        try {
            const payload = { key, description };
            console.log("Saving permission:", payload);

            const url = isNew ? `${API_URL}/v1/admin/permissions` : `${API_URL}/v1/admin/permissions/${id}`;
            const method = isNew ? 'POST' : 'PUT';

            const response = await fetch(url, {
                method,
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                const result = await response.json();
                console.log("Permission saved:", result);
                alert("Permission saved successfully");
                navigate('/admin/permissions');
            } else {
                const errorData = await response.json();
                alert(`Failed to save permission: ${errorData.detail || 'Unknown error'}`);
            }
        } catch (error) {
            console.error("Error saving permission:", error);
            alert("Error saving permission");
        } finally {
            setLoading(false);
        }
    };

    return (
        <SiteLayout>
            <Header icon='lock' title={isNew ? 'Nouvelle Permission' : 'Modifier Permission'} />
            <div style={{ marginBottom: '20px' }}>
                <button className="btn btn-secondary" onClick={() => navigate('/admin/permissions')} style={{ marginBottom: '10px' }}>
                    <i className="material-icons" style={{ verticalAlign: 'middle' }}>arrow_back</i> Retour
                </button>
                <h2 style={{ fontSize: '1.8rem', fontWeight: 'bold', color: '#1e293b' }}>
                    {isNew ? 'Nouvelle Permission' : 'Modifier Permission'}
                </h2>
            </div>

            <div className="box" style={{ padding: '30px' }}>
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <label className="form-label">Clé de Permission (Unique)</label>
                        <input
                            type="text"
                            className="form-input"
                            value={key}
                            onChange={(e) => setKey(e.target.value)}
                            required
                            placeholder="Ex: manage_users"
                            disabled={!isNew} // Usually keys are immutable or require special care
                        />
                        <small style={{ color: '#64748b' }}>Identifiant unique utilisé dans le code (ex: admin_platform)</small>
                    </div>

                    <div className="form-group">
                        <label className="form-label">Description</label>
                        <textarea
                            className="form-input"
                            value={description}
                            onChange={(e) => setDescription(e.target.value)}
                            rows={3}
                            placeholder="Description de la permission..."
                        />
                    </div>

                    <div style={{ marginTop: '30px', display: 'flex', gap: '10px' }}>
                        <button type="submit" className="btn btn-primary" disabled={loading}>
                            {loading ? 'Enregistrement...' : 'Enregistrer'}
                        </button>
                        <button type="button" className="btn btn-secondary" onClick={() => navigate('/admin/permissions')}>
                            Annuler
                        </button>
                    </div>
                </form>
            </div>
        </SiteLayout>
    );
};

export default PermissionsDetails;
